












import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { references } from '@/data';
import { UseFluid } from '@/mixins/UseFluid';
import { IPersona, IReference } from '@/@types';
import MoreOnVue from '@/components/MoreOn.vue';
import ReferenceItemVue from '@/components/ReferenceItem.vue';

const personaModule = namespace('persona');

@Component({
  components: {
    MoreOnVue,
    ReferenceItemVue,
  },
})
export default class References extends Mixins(UseFluid) {
  @personaModule.State('currentPersona') public currentPersona!: IPersona;
  @personaModule.Getter('references') public references!: IReference[];
}
